import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NDtAnchor, NDtButton } from './button';
import { NDtFabAnchor, NDtFabButton, NDtMiniFabAnchor, NDtMiniFabButton } from './fab';
import { NDtIconAnchor, NDtIconButton } from './icon-button';

const declarations = [
  NDtAnchor,
  NDtButton,
  NDtIconAnchor,
  NDtMiniFabAnchor,
  NDtMiniFabButton,
  NDtIconButton,
  NDtFabAnchor,
  NDtFabButton,
];
@NgModule({
  declarations,
  exports: declarations,
  imports: [CommonModule],
})
export class ButtonModule {}
